import { useEffect, useState } from 'react'
import NProgress from 'nprogress'
import { iziplaySupport } from '../tools/api'
import { Question } from '../components/question'
import { Ticket } from '../components/ticket'
import { Button, TextArea, TextField } from '@iziplay/ui-kit'
import './support.css'


import FAQ from '../tools/faq.json'
import { displayNotification, setCurrentPath } from '../state/ui'

function Support() {
  const [subject, setSubject] = useState('')
  const [text, setText] = useState('')
  const [myTickets, setMyTickets] = useState<Iziplay.Ticket[]>([])

  function getUserTickets() {
    NProgress.start()
    iziplaySupport()
      .get('/tickets')
      .then(response => {
        NProgress.inc()
        NProgress.done()

        if (response.data) {
          setMyTickets(response.data)
        }
      })
      .catch(_ => {
        NProgress.done()
      })
  }

  function sendTickets() {
    NProgress.start()
    iziplaySupport()
      .post('/tickets', {
        subject,
        text
      })
      .then(() => {
        NProgress.inc()
        setSubject('')
        setText('')
        getUserTickets()
        NProgress.done()
        return displayNotification('Ticket sent, thank you!', 'success')
      })
      .catch(err => {
        console.log(err.response)
        NProgress.done()
        return displayNotification('Error has occured', 'error')
      })
  }

  useEffect(() => {
    getUserTickets()
    setCurrentPath([])
  }, [])

  const faqs = FAQ.fr.map(elem => (
    <Question key={elem.question} quest={elem.question} resp={elem.response} />
  ))

  return (
    <div className="support scrollable">
      <div className="box">
        <div className="title">FAQ</div>
        {faqs}
      </div>

      <div className="box">
        <div className="title">My tickets</div>
        <div className="element ticketElement">
          {myTickets.length === 0 ? (
            <p>No ticket</p>
          ) : (
            myTickets.map(elem => (
              <Ticket
                key={`${elem.date}_${elem.title}`}
                title={elem.title}
                date={new Date(elem.date).toLocaleString()}
                text={elem.body}
                closed={elem.closed}
              />
            ))
          )}
        </div>
      </div>

      <div className="box">
        <div className="title">Tickets</div>
        <div className="element">
          <TextField
            placeholder="Issue title"
            type="text"
            value={subject}
            onChange={e => setSubject(e.target.value)}
          />
          <TextArea
            placeholder="Describe your issue"
            rows={8}
            value={text}
            onChange={e => setText(e.target.value)}
          />
          <Button variant="contained" color="primary" onClick={sendTickets}>Send</Button>
        </div>
      </div>
    </div>
  )
}

export default Support
